import { useEffect, useState } from "react";
import hasNoValue from "../helpers/hasNoValue";
import useToast, { TOAST_TYPES } from "./useToast";

export default function useAsync(callback, successMsg, errorMsg) {
  const [data, setData] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const [start, setStart] = useState(false);

  const [addToast] = useToast();
  useEffect(() => {
    if (!start) return;

    (async () => {
      setIsLoading(true);
      setError(undefined);
      setData(undefined);
      await callback()
        .then((data) => {
          if (hasNoValue(data)) {
            // addToast(TOAST_TYPES.INFO, "No data found.");
            return;
          }
          setData(data);
          successMsg?.length > 0 && addToast(TOAST_TYPES.SUCCESS, successMsg);
        })
        .catch((err) => {
          setError(errorMsg || err);
          addToast(TOAST_TYPES.ERROR, errorMsg || err?.message);
        })
        .finally(() => {
          setStart(false);
          setIsLoading(false);
        });
    })();
  }, [start, callback, errorMsg, successMsg, addToast]);

  return [setStart, data, isLoading, error, setData];
}
